// extracted by mini-css-extract-plugin
module.exports = {"item":"attachmentItem_item__2Dm5w","grid":"attachmentItem_grid__3fcH_"};